var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',[_c('h5',[_vm._v("全盈+PAY說明")]),_c('ul',{staticClass:"has-type-decimal"},[_c('li',[_vm._v("使用全盈+PAY恕不適用分期付款。")]),_c('li',[_vm._v("全盈+PAY接受信用卡及帳戶付款。")]),_c('li',[_vm._v("消費可使用全家點數全額折抵。")]),_c('li',[_vm._v("付款額度限制：依全盈+PAY官網說明。")])])])
}]

export { render, staticRenderFns }